import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private readonly loggedInSubject = new BehaviorSubject<boolean>(
    !!localStorage.getItem('token') || !!localStorage.getItem('uuidToken')
  );
  isLoggedIn$ = this.loggedInSubject.asObservable();

  constructor(private router: Router) {}

  logout(): void {
    // Keep selectedLanguage; only clear auth/session items.
    localStorage.removeItem('token');
    localStorage.removeItem('uuidToken');
    localStorage.removeItem('formState');

    this.loggedInSubject.next(false);

    // App root always redirects to onboarding.
    this.router.navigateByUrl('/onboarding');
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Retrieve and clean the token (if present)
    const tokenWithBearer = localStorage.getItem('token')?.trim();
    const token =
      tokenWithBearer && tokenWithBearer.startsWith('Bearer ')
        ? tokenWithBearer.substring('Bearer '.length).trim()
        : tokenWithBearer || null;

    const authReq = token
      ? req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        })
      : req;

    return next.handle(authReq);
  }
}

